import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import Sidebar from "./layout/Sidebar";
import AddQuestion from "./add/AddQuestion"
import EditQuestion from "./edit/EditQuestion"
import ViewQuestion from "./view/ViewQuestion"

export default function QuestionPanel() {

  const [data, setData] = useState([]);
  const [course, setCourse]=useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [addform, setaddform] = useState(false);
  const [editform, seteditform] = useState(false);
  const [view, setview] = useState(false);
  const [id, setId] = useState(0);

  const columns = [
    { name: "ID", selector: row => row.id, sortable: true },
    { name: "Question", selector: row => row.question || "N/A", sortable: true },
    { name: "Answer", selector: row => row.answer || "N/A", sortable: true },

    // ✅ Actions Column
    {
      name: "Actions",
      cell: row => (
        <div className="d-flex">
           <button
            className="btn btn-sm btn-color me-2"
            onClick={() => {setview(true);setId(row.id)}}
          >
            <i className="bi bi-eye"></i>
          </button>
          <button
            className="btn btn-sm btn-color me-2"
             onClick={() => {seteditform(true);setId(row.id)}}
          >
            <i className="bi bi-pencil"></i>
          </button>
        </div>
      ),
    },
  ];

  function getData(courseId){
      axios.get(`${process.env.REACT_APP_BASE_URL}api/question/secured/getQuestionByCourseId/`+courseId)
      .then(result=>setData(result.data))
      .catch(err=>console.log(err))
      .finally(setLoading(false));    
  }
  function getCourse(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
        .then(result=>setCourse(result.data))
        .catch(err=>console.log(err));
  }
  useEffect(()=>getCourse(),[]);
  useEffect(()=>getData(1),[1]);

  const filteredData = filterText
    ? data.filter(item =>
        (item.question || "").toLowerCase().includes(filterText.toLowerCase()) ||
        (item.answer || "").toLowerCase().includes(filterText.toLowerCase()) 
      )
    : data;

    return (<>
    <div className="container-fluid">
        {addform && <>
        <div className="dialog-container">
          <AddQuestion event={setaddform}></AddQuestion>
        </div>
        </>}
        {view && <>
        <div className="dialog-container">
          <ViewQuestion event={setview} id={id}></ViewQuestion>
        </div>
        </>}
        {editform && <>
        <div className="dialog-container">
          <EditQuestion event={seteditform} id={id}></EditQuestion>
        </div>
        </>}
   </div>
      <div className="container-fluid">
          <div className="row">
             <div className="col-12 col-md-3 col-lg-2 sidebar-container">
                 <Sidebar></Sidebar>
             </div>
             <div className="col-12 col-md-9 col-lg-10 main-container">
                 <div className="container mt-4">
                  <h2 className="text-center mb-3">Question List</h2>
                  <hr />
    
                  {/* Action Buttons + Search Bar */}
                  <div className="row d-flex justify-content-between align-items-center mb-0">
                    <div className="col-12 col-sm-2">
                        <button className="btn btn-color text-center" onClick={()=>setaddform(true)}><i className="bi bi-plus"></i></button>
                    </div>
                    <div className="col-12 col-lg-2">
                      <select className="form-select" name="courseId" onChange={(e)=>getData(e.target.value)}>
                        {course.map((course)=>
                            <option value={course.id}>{course.name}</option>
                          )}
                      </select>
                    </div>
                    <div className="col-12 col-sm-3">
                      <input
                        type="text"
                        className="form-control"
                        style={{ width: "100%" }}
                        placeholder="Search"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Data Table */}
                  <div className="card shadow" style={{overflow:"auto"}}>
                    <div className="card-body">
                      <DataTable
                        columns={columns}
                        data={filteredData}
                        progressPending={loading}
                        pagination
                        highlightOnHover
                        striped
                      />
                    </div>
                  </div>
                </div>
             </div>
          </div>
      </div> 
    </>);
}